export default {"src":"/_next/static/media/hidden.e5c566d4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};